import $ from 'jquery';

$(document).ready(function() {
    function hideSidePanel() {
        $('.memberSidePanel').removeClass('visible');
        $('.teamSidePanelOverlay').removeClass('visible');
    }

    $('body').append('<div class="teamSidePanelOverlay"></div>');

    $(document).on('click', '[data-panel-id]', function() {
       const panelId = $(this).data('panel-id');
       $('#'+panelId).addClass('visible');
       $('.teamSidePanelOverlay').addClass('visible');
    });

    $(document).on('click', '.teamSidePanelOverlay', hideSidePanel);
    $(document).on('click', '.memberSidePanel__closeButton', hideSidePanel);
});